import jwt from 'jwt-simple';
function decodeToken(token) {
  try {
    return jwt.decode(token, '', true) || {};
  } catch (_unused) {
    return {};
  }
}
export function getConfigTokenScope(state) {
  var token = state.getIn(['config', 'userToken']);
  return decodeToken(token).scope;
}